import * as React from "react";
import { Modal, compose, graphql, withShowFlag, withUser, } from "@atlassiansox/microscopekit";
import { CheckName } from "./check-name";
import sendLinterExemptionsReqMutation from "../../graphql/send-linter-exemptions-req.mutation.graphql";
import styled from "styled-components";
const ToggleStateless = require("@atlaskit/toggle").ToggleStateless;
const DynamicTable = require("@atlaskit/dynamic-table").default;
const FieldTextArea = require("@atlaskit/field-text-area").default;
const ExceptionsHeading = styled.div `
  margin-bottom: 15px;
`;
export class ExemptionsView extends React.Component {
    constructor(props) {
        super(props);
        this.convertLinterExemptionsToMap = (exemptionsList) => {
            const exemptionsMap = {};
            exemptionsList.forEach((exemption) => {
                exemptionsMap[exemption.checkName] = {
                    id: exemption.checkName,
                    checkName: exemption.checkName,
                    isExempt: exemption.isExempt,
                    reason: exemption.reason,
                    submittedBy: exemption.submittedBy,
                };
            });
            return exemptionsMap;
        };
        this.cancelSettingsModal = async () => {
            this.props.onClose();
        };
        this.convertMapToLinterExemptions = (exemptionsMap) => {
            let exemptionsList = [];
            Object.keys(exemptionsMap).forEach((checkName) => {
                const exemption = exemptionsMap[checkName];
                exemptionsList.push(exemption);
            });
            return exemptionsList;
        };
        this.saveSettingsModal = async () => {
            this.setState({ sendExemptionsInProgress: true });
            try {
                const differences = this.findNewOrUpdatedExemptions();
                const mutationArgs = {
                    id: this.props.serviceName,
                    linterExemption: differences,
                };
                if (differences.length > 0) {
                    if (!this.findInvalidExemptions()) {
                        await this.props.sendLinterExemptionsReq({
                            variables: {
                                id: this.props.serviceName,
                                linterExemptionsInput: mutationArgs,
                            },
                        });
                        this.props.showFlag({
                            type: "success",
                            title: "Linter settings saved.",
                            message: "Changes will be applied the next time checks are run.",
                        });
                        this.props.onClose();
                    }
                    else {
                        this.setState({ sendExemptionsInProgress: false });
                    }
                }
                else {
                    this.setState({ sendExemptionsInProgress: false });
                    this.props.onClose();
                }
            }
            catch (e) {
                this.setState({ sendExemptionsInProgress: false });
                this.props.showFlag({
                    type: "error",
                    title: "Error saving exemptions",
                    message: "Something went wrong. Please try again",
                });
                alert(e.message);
                console.error(e);
            }
        };
        this.findNewOrUpdatedExemptions = () => {
            const { updatedCheckNames } = this.state;
            const { updatedExemptions } = this.state;
            let differences = [];
            this.convertMapToLinterExemptions(updatedExemptions).forEach((exemption) => {
                if (updatedCheckNames.includes(exemption.checkName)) {
                    differences.push(exemption);
                }
            });
            return differences;
        };
        this.findInvalidExemptions = () => {
            const { exemptionErrors } = this.state;
            const { updatedCheckNames } = this.state;
            const { updatedExemptions } = this.state;
            let invalidExemptions = false;
            this.convertMapToLinterExemptions(updatedExemptions).forEach((exemption) => {
                if (updatedCheckNames.includes(exemption.checkName) &&
                    exemption.isExempt &&
                    (exemption.reason === "" || exemption.reason.length < 1)) {
                    this.setState((prevState) => ({
                        exemptionErrors: {
                            ...prevState.exemptionErrors,
                            [exemption.checkName]: true,
                        },
                    }));
                    invalidExemptions = true;
                }
            });
            this.setState({ exemptionErrors });
            return invalidExemptions;
        };
        this.isExemptionInvalid = (checkName) => this.state.exemptionErrors[checkName] !== undefined &&
            this.state.exemptionErrors[checkName];
        this.highlightEmptyReason = (checkName) => {
            const exemption = this.state.updatedExemptions[checkName];
            return exemption !== undefined
                ? this.isExemptionInvalid(exemption.checkName)
                : false;
        };
        this.getReason = (checkName) => this.state.updatedExemptions[checkName] === undefined
            ? ""
            : this.state.updatedExemptions[checkName].reason;
        this.getIsExempt = (checkName) => this.state.updatedExemptions[checkName] === undefined
            ? false
            : this.state.updatedExemptions[checkName].isExempt;
        this.updateIsExempt = (checkName, newIsExempt) => {
            var _a, _b, _c;
            const { updatedExemptions } = this.state;
            const { updatedCheckNames } = this.state;
            const username = (_c = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.username) !== null && _c !== void 0 ? _c : "";
            if (updatedExemptions[checkName] === undefined) {
                updatedExemptions[checkName] = {
                    id: checkName,
                    checkName,
                    isExempt: newIsExempt,
                    reason: "None",
                    submittedBy: username,
                };
                updatedCheckNames.push(checkName);
            }
            else {
                updatedExemptions[checkName].isExempt = newIsExempt;
                updatedExemptions[checkName].submittedBy = username;
                updatedCheckNames.push(checkName);
            }
            if (newIsExempt === false) {
                updatedExemptions[checkName].reason = "None";
            }
            this.setState({ updatedExemptions, updatedCheckNames });
        };
        this.updatePage = (pageNum, _) => {
            this.setState({ pageNumber: pageNum });
        };
        this.updateReason = (checkName, newReason) => {
            var _a, _b, _c;
            const { updatedExemptions } = this.state;
            const { updatedCheckNames } = this.state;
            const username = (_c = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.username) !== null && _c !== void 0 ? _c : "";
            if (updatedExemptions[checkName] === undefined) {
                // tslint:disable-next-line:no-console
                updatedExemptions[checkName] = {
                    id: checkName,
                    checkName,
                    isExempt: false,
                    reason: newReason,
                    submittedBy: username,
                };
                updatedCheckNames.push(checkName);
            }
            else {
                updatedExemptions[checkName].reason = newReason;
                updatedExemptions[checkName].submittedBy = username;
                updatedCheckNames.push(checkName);
            }
            this.setState({ updatedExemptions, updatedCheckNames });
        };
        this.state = {
            updatedExemptions: this.convertLinterExemptionsToMap(props.linterExemptions),
            updatedCheckNames: [],
            sendExemptionsInProgress: false,
            exemptionErrors: {},
            pageNumber: 1,
        };
    }
    render() {
        let settingsHead = {
            cells: [
                {
                    key: "checkname",
                    content: "Check",
                    isSortable: true,
                    shouldTruncate: false,
                },
                {
                    key: "componentname",
                    content: "Component",
                    isSortable: true,
                    shouldTruncate: false,
                },
                {
                    key: "exemptionReason",
                    content: "Why is the service exempt?",
                    isSortable: false,
                    shouldTruncate: false,
                    width: 350,
                },
                { key: "exempt", content: "Exemption", isSortable: true },
            ],
        };
        let settingsCells = this.props.scores.map((score) => ({
            cells: [
                {
                    key: score.checkName.split(".")[1],
                    content: (React.createElement("span", null,
                        React.createElement(CheckName, null, score.checkName.split(".")[1]))),
                },
                {
                    key: score.checkName.split(".")[0],
                    content: React.createElement(CheckName, null, score.checkName.split(".")[0]),
                },
                {
                    key: "reason." + score.checkName,
                    content: this.getIsExempt(score.checkName) ? (React.createElement(FieldTextArea, { shouldFitContainer: true, isInvalid: this.highlightEmptyReason(score.checkName), value: decodeURI(this.getReason(score.checkName)), onChange: (event) => {
                            this.updateReason(score.checkName, encodeURI(event.target.value));
                        } })) : (React.createElement("span", null)),
                },
                {
                    key: "toggle." + score.checkName,
                    content: (React.createElement(ToggleStateless, { isChecked: this.getIsExempt(score.checkName), onChange: (event) => {
                            this.updateIsExempt(score.checkName, event.currentTarget.checked);
                        } })),
                },
            ],
        }));
        return (React.createElement(Modal, { isOpen: true, width: "x-large", heading: `Linter settings for ${this.props.serviceName}`, actions: [
                { text: "Save", onClick: this.saveSettingsModal },
                { text: "Cancel", onClick: this.cancelSettingsModal },
            ], onClose: this.props.onClose },
            React.createElement(ExceptionsHeading, null,
                React.createElement("span", null, "Exemptions are applied next time a Check is run.")),
            React.createElement(DynamicTable, { head: settingsHead, rows: settingsCells, rowsPerPage: 10, loadingSpinnerSize: "large", isLoading: false, isFixedSize: false, onSetPage: this.updatePage, 
                // table re-renders when content is updated, so page number is duplicated
                // in Exemption's state so that the proper page number can be restored on render
                page: this.state.pageNumber })));
    }
}
export const Exemptions = compose(graphql(sendLinterExemptionsReqMutation, {
    name: "sendLinterExemptionsReq",
}), withUser, withShowFlag)(ExemptionsView);
